var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"host"},[_c('div',{staticClass:"vm-table-wrap"},[_c('table',{staticClass:"vm-table sticky"},[_c('thead',[_vm._t("header")],2),_c('tbody',[_vm._t("body")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }